import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { Typography } from 'transfix-ui/core'
import { LoadableValue } from './LoadableValue'

type TTitleColor =
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'textPrimary'
  | 'textSecondary'
  | 'error'
  | 'initial'
  | undefined

interface IValueField {
  title: string
  value?: Maybe<string | number> | boolean | React.FC | React.ReactNode
  loading?: boolean
  percent?: boolean
  color?: Maybe<string>
  fallback?: string
  titleColor?: Maybe<TTitleColor>
}

export const ValueField = ({
  color,
  fallback,
  loading = false,
  percent,
  title,
  titleColor,
  value,
}: IValueField) => {
  return (
    <div>
      <Typography color={titleColor || 'textSecondary'} variant='caption'>
        {title}
      </Typography>
      <Typography variant='body2'>
        <LoadableValue
          loading={loading}
          value={value}
          percent={percent}
          color={color}
          fallback={fallback}
        />
      </Typography>
    </div>
  )
}
